import { useState } from "react";
import { intl } from "LocaleWrapper";
import { Card } from "@cofano/cck";
import Navigation from "components/layout/Navigation";
import AccountPermissionSelect from "view/users/components/selects/AccountPermissionSelect";
import { AdminNavigationItem } from "view/admin/utils/admin.types";
import { Permission } from "__generated__/enums";

const filterByPermission = (items: AdminNavigationItem[], permission: Permission): AdminNavigationItem[] =>
	items.reduce<AdminNavigationItem[]>((filtered, item) => {
		if (item.permissions.length > 0 && !item.permissions.includes(permission)) {
			return filtered;
		}

		const children = item.children?.filter(
			child => child.permissions.length === 0 || child.permissions.includes(permission),
		);
		if (item.children && item.children.length > 0 && children?.length === 0) {
			return filtered;
		}

		filtered.push({ ...item, children });
		return filtered;
	}, []);

const AdminNavigationExample = ({ navigationItems }: { navigationItems: AdminNavigationItem[] }) => {

	const [ selectedUserType, selectUserType ] = useState(Permission.Administrator);

	const items = filterByPermission(navigationItems, selectedUserType);

	return (
		<Card title={intl.formatMessage({ id: "EXAMPLE" })}>
			<AccountPermissionSelect
				clearable={false}
				value={selectedUserType}
				onChange={(permission) => {
					if (permission) {
						selectUserType(permission);
					}
				}} />

			<Navigation
				path="/"
				navigationItems={items}
				disableNavigation
			/>
		</Card>
	);
};

export default AdminNavigationExample;
